import { useState } from "react";
import { ChevronDown } from "lucide-react";

const faqs = [
  {
    question: "What is Car Hangout?",
    answer:
      "Car Hangout is the first app built exclusively for car enthusiasts. Share your rides, track your builds, discover events, and connect with a passionate community all in one place.",
  },
  {
    question: "Who can use Car Hangout?",
    answer: "Any car lover! From imports and exotics to muscle cars, classics, or trucks, the app is designed for enthusiasts of all types and experience levels.",
  },
  {
    question: "How do I share my car?",
    answer: "Post photos, videos, and updates about your ride. Build your profile, track your mods, and showcase your car to a community that truly cares.",
  },
  {
    question: "How can I find car meets and events?",
    answer: "Use the interactive map to discover nearby car meets, shows, and boosted events. You can also plan and promote your own events easily.",
  },
  {
    question: "What is Vendor Lane?",
    answer: "Vendor Lane connects you with trusted shops, garages, and professionals. Enjoy exclusive member discounts on performance parts, detailing services, and more.",
  },
  {
    question: "What is Challenge My Ride?",
    answer:
      "Challenge My Ride lets you compete with other enthusiasts in fun head-to-head batles — from stance competitions to horsepower showdowns — with the community voting for winners.",
  },
];

export default function FAQ() {
  const [openIndexes, setOpenIndexes] = useState([0]);
  const [hoveredIndex, setHoveredIndex] = useState(null);

  return (
    <div id="faqs" className=" bg-[#0b0b0b] text-white flex flex-col  items-center xxs:mt-1 mt-16 px-6 py-16">
      <h1 className="text-2xl md:text-[30px] lg:text-[34px] font-semibold font-noto-sans mb-3 text-center"style={{ transform: 'scaleY(1.3)' }}>
        FAQS FOR CAR <span className="text-[#FF4D00]">ENTHUSIASTS</span>
      </h1>
      <p className="text-gray-200 text-sm md:text-base lg:text-lg font-noto-sans leading-relaxed font-medium max-w-3xl lg:max-w-4xl xl:max-w-3xl text-center mb-12 mt-3">
        Everything you need to know about Car Hangout from sharing your ride to
        finding events and connecting with the community.
      </p>

      <div className="w-full max-w-3xl lg:max-w-4xl xl:max-w-5xl space-y-3 md:space-y-4">
        {faqs.map((faq, index) => (
          <div
            key={index}
            className={`rounded-lg transition-all duration-[1500ms] overflow-hidden relative cursor-pointer ${
              openIndexes.includes(index)
                ? "bg-[#141415] border-[#FFFFFF0D]"
                : "border-[#FFFFFF0D]"
            }`}
            style={{
              ...(!openIndexes.includes(index) ? { background: '#FFFFFF05' } : {}),
              transition: 'all 1.2s ease'
            }}
            onMouseEnter={() => setHoveredIndex(index)}
            onMouseLeave={() => setHoveredIndex(null)}
          >
            {hoveredIndex === index && (
              <div 
                style={{
                  position: 'absolute',
                  top: 10,
                  left: '10%',
                  right: 0,
                  width: '100%',
                  height: '50px',
                  background: 'linear-gradient(to right, rgba(194, 65, 12, 0.2), rgba(194, 65, 12, 0.3), transparent)',
                  borderRadius: '24px 24px 0 0',
                  pointerEvents: 'none',
                  zIndex: 1,
                  opacity: 0.9,
                  filter: 'blur(60px)'
                }}
              ></div>
            )}
            <button
              onClick={() => {
                setOpenIndexes((prev) => {
                  if (prev.includes(index)) {
                    return prev.filter((i) => i !== index);
                  }
                  return [...prev, index];
                });
              }}
              className="w-full flex justify-between items-center px-6 md:px-8 py-3 md:py-4 text-left focus:outline-none transition-colors duration-[1200ms] relative z-10"
              // style={{ background: '#FFFFFF05' }}
            >
              <span className="text-white text-base md:text-base lg:text-[18px]  font-regular font-noto-sans leading-tight pr-4">
                {faq.question}
              </span>
              <ChevronDown
                className={`w-5 h-5 md:w-6 md:h-6 text-white transition-transform duration-[1200ms] flex-shrink-0 ${
                  openIndexes.includes(index) ? "rotate-180" : ""
                }`}
              />
            </button>
            <div
              className="px-6 md:px-8 pb-0 md:pb-1 pt-0 relative z-10 overflow-hidden"
              style={{
                maxHeight: openIndexes.includes(index) ? "340px" : "0px",
                paddingBottom: openIndexes.includes(index) ? "12px" : "0px",
                transition: openIndexes.includes(index)
                  ? "max-height 1.6s ease, padding-bottom 1.6s ease"
                  : "max-height 0.6s ease, padding-bottom 1.6s ease"
              }}
            >
              <p className="text-gray-200 text-sm md:text-base lg:text-base font-regular leading-normal font-noto-sans py-2">
                {faq.answer}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
